import { render } from "./Sizes.vue?vue&type=template&id=73391bdc"
import script from "./Sizes.vue?vue&type=script&lang=js"
export * from "./Sizes.vue?vue&type=script&lang=js"
script.render = render

export default script